let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8fEsa")).then(() => parcelRequire('dUYQ5'));